import { ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { IAlarmRecipientDto } from "../../services/admin-report-data-service/Models";


export function RecipientRenderer({
    value,
    //data,
}: ICellRendererParams) {

    const recipient = value as IAlarmRecipientDto;

    return (


        <Typography component="span" 
            variant="body2" 
            sx={{ 
                fontSize: ".8rem",
                fontWeight: recipient?.recipientDisabled ? 'bold' : undefined,
                textDecoration: recipient?.recipientDisabled ? 'line-through' : undefined,
            }}>
            {recipient?.recipientTo ?? "(no recipients)"}
        </Typography>

            



    )
}

